export const selectTeamState = (state) => state.team;
